export const StatusIconType = {
  'info': 'icon-info',
  'error': 'icon-x-circle',
  'warning': 'icon-alert-circle',
  'success': 'icon-check-circle',
  'loading': 'icon-loader'
};
